import type { Moment } from 'moment';

/**
 * Zodiac sign for a birth date, as its silhouette image and description id.
 * Its own module (re-exported from utils.js) so callers that must not pull in
 * utils.js's store import — the ClientV2 leaves — can still use it.
 */
export const getConstellation = (momentObj?: Moment | null): { image: string; descIntl: string } | undefined => {
  if (!momentObj) {
    return undefined;
  }

  const month = momentObj.month() + 1;
  const day = momentObj.date();

  let id: string | undefined;

  if (month === 12) {
    id = day < 22 ? 'sagittarius' : 'goat';
  } else if (month === 1) {
    id = day < 20 ? 'goat' : 'aquarius';
  } else if (month === 2) {
    id = day < 19 ? 'aquarius' : 'pisces';
  } else if (month === 3) {
    id = day < 21 ? 'pisces' : 'aries';
  } else if (month === 4) {
    id = day < 20 ? 'aries' : 'bull';
  } else if (month === 5) {
    id = day < 21 ? 'bull' : 'gemini';
  } else if (month === 6) {
    id = day < 21 ? 'gemini' : 'cancer';
  } else if (month === 7) {
    id = day < 23 ? 'cancer' : 'leo';
  } else if (month === 8) {
    id = day < 23 ? 'leo' : 'virgo';
  } else if (month === 9) {
    id = day < 23 ? 'virgo' : 'libra';
  } else if (month === 10) {
    id = day < 23 ? 'libra' : 'scorpion';
  } else if (month === 11) {
    id = day < 22 ? 'scorpion' : 'sagittarius';
  }

  return { image: `/img/${id}.png`, descIntl: `cstlt-${id}` };
};
